import { Box, Link, Typography } from "@mui/material";
import Footer from "../../components/layouts/Footer/OverviewFooter";
import Header from "../../components/layouts/Header/OverviewHeader";
import * as styles from "./datenschutzStyles";

const Datenschutz: React.FC = () => {
    return (
        <Box sx={styles.pageContainer}>
            <Header />

            <Box sx={styles.contentContainer}>
                <Typography variant="h1" sx={styles.pageTitle}>
                    Datenschutzerklärung
                </Typography>

                <Box sx={styles.section}>
                    <Typography variant="h2" sx={styles.sectionTitle}>
                        1. Datenschutz auf einen Blick
                    </Typography>

                    <Typography variant="h3" sx={styles.subsectionTitle}>
                        Allgemeine Hinweise
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Die folgenden Hinweise geben einen einfachen Überblick
                        darüber, was mit Ihren personenbezogenen Daten passiert,
                        wenn Sie diese Website besuchen. Personenbezogene Daten
                        sind alle Daten, mit denen Sie persönlich identifiziert
                        werden können. Ausführliche Informationen zum Thema
                        Datenschutz entnehmen Sie unserer unter diesem Text
                        aufgeführten Datenschutzerklärung.
                    </Typography>

                    <Typography variant="h3" sx={styles.subsectionTitle}>
                        Datenerfassung auf dieser Website
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        Wer ist verantwortlich für die Datenerfassung auf dieser
                        Website?
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Die Datenverarbeitung auf dieser Website erfolgt durch
                        den Websitebetreiber. Dessen Kontaktdaten können Sie dem
                        Abschnitt „Hinweis zur Verantwortlichen Stelle" in
                        dieser Datenschutzerklärung entnehmen.
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        Wie erfassen wir Ihre Daten?
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Ihre Daten werden zum einen dadurch erhoben, dass Sie
                        uns diese mitteilen. Hierbei kann es sich z. B. um Daten
                        handeln, die Sie in ein Kontaktformular eingeben.
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Andere Daten werden automatisch oder nach Ihrer
                        Einwilligung beim Besuch der Website durch unsere
                        IT-Systeme erfasst. Das sind vor allem technische Daten
                        (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des
                        Seitenaufrufs). Die Erfassung dieser Daten erfolgt
                        automatisch, sobald Sie diese Website betreten.
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        Wofür nutzen wir Ihre Daten?
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Ein Teil der Daten wird erhoben, um eine fehlerfreie
                        Bereitstellung der Website zu gewährleisten. Andere
                        Daten können zur Analyse Ihres Nutzerverhaltens
                        verwendet werden. Sofern über die Website Verträge
                        geschlossen oder angebahnt werden können, werden die
                        übermittelten Daten auch für Vertragsangebote,
                        Bestellungen oder sonstige Auftragsanfragen verarbeitet.
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        Welche Rechte haben Sie bezüglich Ihrer Daten?
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Sie haben jederzeit das Recht, unentgeltlich Auskunft
                        über Herkunft, Empfänger und Zweck Ihrer gespeicherten
                        personenbezogenen Daten zu erhalten. Sie haben außerdem
                        ein Recht, die Berichtigung oder Löschung dieser Daten
                        zu verlangen. Wenn Sie eine Einwilligung zur
                        Datenverarbeitung erteilt haben, können Sie diese
                        Einwilligung jederzeit für die Zukunft widerrufen.
                        Außerdem haben Sie das Recht, unter bestimmten Umständen
                        die Einschränkung der Verarbeitung Ihrer
                        personenbezogenen Daten zu verlangen. Des Weiteren steht
                        Ihnen ein Beschwerderecht bei der zuständigen
                        Aufsichtsbehörde zu.
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Hierzu sowie zu weiteren Fragen zum Thema Datenschutz
                        können Sie sich jederzeit an uns wenden.
                    </Typography>
                </Box>

                <Box sx={styles.section}>
                    <Typography variant="h2" sx={styles.sectionTitle}>
                        2. Hosting
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wir hosten die Inhalte unserer Website bei folgendem
                        Anbieter:
                    </Typography>

                    <Typography variant="h3" sx={styles.subsectionTitle}>
                        Hetzner
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Anbieter ist die Hetzner Online GmbH, Industriestr. 25,
                        91710 Gunzenhausen (nachfolgend Hetzner).
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Details entnehmen Sie der Datenschutzerklärung von
                        Hetzner:{" "}
                        <Link
                            href="https://www.hetzner.com/de/legal/privacy-policy/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={styles.link}
                        >
                            https://www.hetzner.com/de/legal/privacy-policy/
                        </Link>
                        .
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Die Verwendung von Hetzner erfolgt auf Grundlage von
                        Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes
                        Interesse an einer möglichst zuverlässigen Darstellung
                        unserer Website. Sofern eine entsprechende Einwilligung
                        abgefragt wurde, erfolgt die Verarbeitung ausschließlich
                        auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
                        Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
                        von Cookies oder den Zugriff auf Informationen im
                        Endgerät des Nutzers (z. B. Device-Fingerprinting) im
                        Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit
                        widerrufbar.
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        Auftragsverarbeitung
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wir haben einen Vertrag über Auftragsverarbeitung (AVV)
                        zur Nutzung des oben genannten Dienstes geschlossen.
                        Hierbei handelt es sich um einen datenschutzrechtlich
                        vorgeschriebenen Vertrag, der gewährleistet, dass dieser
                        die personenbezogenen Daten unserer Websitebesucher nur
                        nach unseren Weisungen und unter Einhaltung der DSGVO
                        verarbeitet.
                    </Typography>
                </Box>

                <Box sx={styles.section}>
                    <Typography variant="h2" sx={styles.sectionTitle}>
                        3. Allgemeine Hinweise und Pflichtinformationen
                    </Typography>

                    <Typography variant="h3" sx={styles.subsectionTitle}>
                        Datenschutz
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer
                        persönlichen Daten sehr ernst. Wir behandeln Ihre
                        personenbezogenen Daten vertraulich und entsprechend den
                        gesetzlichen Datenschutzvorschriften sowie dieser
                        Datenschutzerklärung.
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wenn Sie diese Website benutzen, werden verschiedene
                        personenbezogene Daten erhoben. Personenbezogene Daten
                        sind Daten, mit denen Sie persönlich identifiziert
                        werden können. Die vorliegende Datenschutzerklärung
                        erläutert, welche Daten wir erheben und wofür wir sie
                        nutzen. Sie erläutert auch, wie und zu welchem Zweck das
                        geschieht.
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wir weisen darauf hin, dass die Datenübertragung im
                        Internet (z. B. bei der Kommunikation per E-Mail)
                        Sicherheitslücken aufweisen kann. Ein lückenloser Schutz
                        der Daten vor dem Zugriff durch Dritte ist nicht
                        möglich.
                    </Typography>

                    <Typography variant="h3" sx={styles.subsectionTitle}>
                        Hinweis zur verantwortlichen Stelle
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Die verantwortliche Stelle für die Datenverarbeitung auf
                        dieser Website ist:
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        consider it GmbH
                        <br />
                        Wilma-Witte-Stieg 1<br />
                        22047 Hamburg
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Telefon: +4940228689110
                        <br />
                        E-Mail: hello@consider-it.de
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Verantwortliche Stelle ist die natürliche oder
                        juristische Person, die allein oder gemeinsam mit
                        anderen über die Zwecke und Mittel der Verarbeitung von
                        personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o.
                        Ä.) entscheidet.
                    </Typography>

                    <Typography variant="h3" sx={styles.subsectionTitle}>
                        Datenschutzbeauftragter
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wir haben einen Datenschutzbeauftragten benannt.
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Datenschutzbeauftragter
                        <br />
                        consider it GmbH
                        <br />
                        Wilma-Witte-Stieg 1<br />
                        22047 Hamburg
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Telefon: +4940228689110
                        <br />
                        E-Mail: dsb@consider-it.de
                    </Typography>
                </Box>

                <Box sx={styles.section}>
                    <Typography variant="h2" sx={styles.sectionTitle}>
                        4. Analyse-Tools und Werbung
                    </Typography>

                    <Typography variant="h3" sx={styles.subsectionTitle}>
                        Matomo
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Diese Website benutzt den Open Source Webanalysedienst
                        Matomo.
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Mit Hilfe von Matomo sind wir in der Lage Daten über die
                        Nutzung unserer Website durch die Websitebesucher zu
                        erfassen und zu analysieren. Hierdurch können wir u. a.
                        herausfinden, wann welche Seitenaufrufe getätigt wurden
                        und aus welcher Region sie kommen. Außerdem erfassen wir
                        verschiedene Logdateien (z. B. IP-Adresse, Referrer,
                        verwendete Browser und Betriebssysteme) und können
                        messen, ob unsere Websitebesucher bestimmte Aktionen
                        durchführen (z. B. Klicks, Käufe u. Ä.).
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        IP-Anonymisierung
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Bei der Analyse mit Matomo setzen wir IP-Anonymisierung
                        ein. Hierbei wird Ihre IP-Adresse vor der Analyse
                        gekürzt, sodass Sie Ihnen nicht mehr eindeutig
                        zuordenbar ist.
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        Cookielose Analyse
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wir haben Matomo so konfiguriert, dass Matomo keine
                        Cookies in Ihrem Browser speichert.
                    </Typography>

                    <Typography variant="h4" sx={styles.subSubsectionTitle}>
                        Hosting
                    </Typography>
                    <Typography variant="body1" sx={styles.paragraph}>
                        Wir hosten Matomo ausschließlich auf unseren eigenen
                        Servern, sodass alle Analysedaten bei uns verbleiben und
                        nicht weitergegeben werden.
                    </Typography>
                </Box>
            </Box>

            <Footer />
        </Box>
    );
};

export default Datenschutz;
